exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-icon-rank[data-v-1617813b] {\r\n  display: inline-block;\r\n  cursor: pointer;\r\n  fill: #671E75;\r\n  width: 20px;\r\n  height: 20px;\r\n  font-size: 21px;\n}\r\n", ""]);

// exports
